import { writable } from "svelte/store";

export function storage(key: string) {
    const { subscribe, set } = writable(localStorage.getItem(key) || "");
    return {
        set: (v: string) => {
            localStorage.setItem(key, v);
            set(v);
        },
        subscribe: subscribe,
    };
}
